import { observer } from 'mobx-react-lite'
import { Typography } from 'shared/ui'
import styles from './styles.module.scss'

export const ScoreElaborationTab = observer(() => {
  return (
    <div className={styles.tabContent}>
      <Typography ariaLabel={'scoreElaboration'} variant={'body-rg-medium'}>
        Score elaboration
      </Typography>
    </div>
  )
})
